import { Component, computed, HostListener, inject} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { AppToolbar } from '../../components/app-toolbar/app-toolbar';

import { PROJECTS } from '../../data/projects.data';

@Component({
  selector: 'app-project-page',
  standalone: true,
  imports: [CommonModule, RouterLink, AppToolbar],
  templateUrl: './project-page.html',
  styleUrl: './project-page.scss',
})
export class ProjectPage {
  private route = inject(ActivatedRoute);

  params = toSignal(
    this.route.paramMap.pipe(
      map((params) => ({
        slug: params.get('slug') ?? 'fcs',
        view: params.get('view') ?? 'title',
      })),
    ),
    {
      initialValue: {
        slug: 'fcs',
        view: 'title',
      },
    },
  );

  project = computed(() => {
    return PROJECTS.find((project) => project.slug === this.params().slug) ?? PROJECTS[0];
  });

  view = computed(() => this.params().view);

  nextProject = computed(() => {
    return PROJECTS.find((project) => project.slug === this.project().nextSlug) ?? PROJECTS[0];
  });

  galleryProgress = 0;

  @HostListener('window:scroll')
  onScroll(): void {
    if (this.view() !== 'gallery') {
      return;
    }

    const gallery = document.querySelector('.project-gallery') as HTMLElement | null;

    if (!gallery) {
      return;
    }

    const rect = gallery.getBoundingClientRect();
    const scrollable = gallery.offsetHeight - window.innerHeight;

    if (scrollable <= 0) {
      this.galleryProgress = 100;
      return;
    }

    const scrolled = Math.min(Math.max(-rect.top, 0), scrollable);
    this.galleryProgress = Math.round((scrolled / scrollable) * 100);
  }
}
